import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { CommonApiService } from "src/app/services/common-api.service";
import { API } from "../../models/api.enum";
import { IExtensionAgentListResponse } from "../../models/extension-agentlist.model";
import {
  deleteExtensionAgent,
  deleteExtensionAgentFailure,
  deleteExtensionAgentSuccess,
  loadExtensionAgents,
  loadExtensionAgentsFailure,
  loadExtensionAgentsSuccess,
} from "./extension-agentlist.actions";
import { AlertService } from "src/app/services/alert.service";

@Injectable()
export class ExtensionAgentListEffects {
  constructor(
    private actions$: Actions,
    private commonApiService: CommonApiService,
    private alertService: AlertService
  ) {}

  loadExtensionAgents$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadExtensionAgents),
      mergeMap(({ orgId }) => {
        return this.commonApiService
          .get<IExtensionAgentListResponse>(API.EXTENSION_AGENT_LIST, {
            orgId,
          })
          .pipe(
            map((response) => loadExtensionAgentsSuccess({ response })),
            catchError((error) => of(loadExtensionAgentsFailure({ error })))
          );
      })
    );
  });

  deleteExtensionAgent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteExtensionAgent),
      mergeMap(({ agentId, orgId }) => {
        return this.commonApiService
          .delete(`${API.EXTENSION_AGENT_LIST}/${agentId}`)
          .pipe(
            map(() => {
              this.alertService.alertSuccess(
                "Success",
                "Extension deleted successfully"
              );
              return deleteExtensionAgentSuccess({ agentId, orgId });
            }),
            catchError((error) => {
              this.alertService.alertDanger(
                "Error",
                error?.error?.message || "Failed to delete extension"
              );
              return of(deleteExtensionAgentFailure({ error }));
            })
          );
      })
    );
  });

  reloadExtension$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteExtensionAgentSuccess),
      map((action) => loadExtensionAgents({ orgId: action.orgId }))
    );
  });
}
